import { httpsCallable } from 'firebase/functions';
import { ExternalConnectionsProviders } from 'shared/types/external-connections';

import { getFunctions } from './helpers';

export const getExternalAuthRedirected = async (
  provider: ExternalConnectionsProviders,
) => {
  const functions = getFunctions();
  const getRedirectUrl = httpsCallable<
    { provider: ExternalConnectionsProviders },
    string
  >(functions, 'externalConnections-getAuthenticationURL');

  const redirectUrl = await getRedirectUrl({ provider });
  window.location.href = redirectUrl.data;
};
